import { render, staticRenderFns } from "./FormLesiones.vue?vue&type=template&id=3dcb806b"
import script from "./FormLesiones.vue?vue&type=script&lang=js"
export * from "./FormLesiones.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports